import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import _ from 'lodash';

/**
 * Renders a routerLink anchor inside a grid cell — a real link, so it supports
 * cmd/ctrl-click and middle-click to open in a new tab while a plain click does
 * in-app navigation. Configure via cellRendererParams:
 *   label          - link text
 *   showPlus       - prepend a "+" glyph
 *   routerLink     - the router path array, e.g. ['/services/template']
 *   getQueryParams - (rowData) => queryParams object
 *   hide           - (rowData) => boolean; when true the link isn't rendered
 */
@Component({
    selector: 'app-table-cell-link',
    templateUrl: './table-cell-link.component.html',
    styleUrls: ['./table-cell-link.component.scss'],
    standalone: false,
})
export class TableCellLinkComponent implements ICellRendererAngularComp {
    link: any[] = [];
    queryParams: Record<string, any> = {};
    label = '';
    showPlus = false;
    hidden = false;

    agInit(params: ICellRendererParams): void {
        this.apply(params);
    }

    refresh(params: ICellRendererParams): boolean {
        this.apply(params);
        return true;
    }

    private apply(params: any): void {
        const row = _.get(params, 'data', {});
        this.label = params.label || '';
        this.showPlus = !!params.showPlus;
        this.link = params.routerLink || [];
        this.queryParams = typeof params.getQueryParams === 'function' ? params.getQueryParams(row) : {};
        this.hidden = typeof params.hide === 'function' ? !!params.hide(row) : false;
    }
}
